import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import { MatIconModule } from '@angular/material/icon';
import { Translate } from '../../utils/translate';
import { OrderService } from 'src/app/core/services/order.service';
import { FeedbackModalComponent } from '../feedback-modal/feedback-modal.component';
import { MatDialog } from '@angular/material/dialog';
import i18next from 'i18next';
import { CampaignRaffleStatus, CampaignTypes } from '../../model/campaign.enum';
import { RequestType } from '../../model/requestType.enum';
import { MatTableModule } from '@angular/material/table';
import { StorageService } from 'src/app/core/storage/storage.service';
import { User } from '../../model/user.model';
import { DragDropComponent } from '../drag-drop/drag-drop.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentKey } from '../../model/request-detail.model';
import { DataEntryService } from 'src/app/core/services/data-entry.service';
import saveAs from 'file-saver';
import { SharedModule } from '../../shared.module';
import { LeasingStatusDocs } from '../../model/leasing.enum';

@Component({
  standalone: true,
  selector: 'app-detail-leasing-request',
  templateUrl: './detail-leasing-request.component.html',
  styleUrls: ['./detail-leasing-request.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    MatIconModule,
    MatTableModule,
    MatTooltipModule,
    SharedModule
  ]
})
export class DetailLeasingRequestComponent implements OnInit {
  @Input() car: any;
  @Input() additionalInfo: any;
  @Input() orderInfo!: any;

  carTitles: Array<{ key: string; value: any }> = [];

  displayedColumns: string[] = [
    'date',
    'documentType',
    'document',
    'status',
    'actions'
  ];
  dataSource: any[] = [];

  remainingHours = 0;
  pastDate = false;
  raffleStatusEnum = CampaignRaffleStatus;
  campaignTypesEnum = CampaignTypes;
  requestTypesEnum = RequestType;
  addDocumentDisabled = false;
  user!: User;
  spinner = false;
  retributionText = '';
  spinnerImage = false;

  constructor(
    public translate: Translate,
    private orderService: OrderService,
    public dialog: MatDialog,
    private storageService: StorageService,
    public cdr: ChangeDetectorRef,
    private dataEntryService: DataEntryService
  ) {
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');
    }

    this.dataSource = this.filterDocumentsByUserCategory();
  }

  ngOnInit(): void {
    if (!!this.orderInfo && !!this.orderInfo.vehicleGroupTitles) {
      this.carTitles = Object.entries(this.orderInfo.vehicleGroupTitles).map(
        ([key, value]) => ({
          key,
          value
        })
      );
    }

    if (!!this.orderInfo && !!this.orderInfo.campaignDataDTO) {
      if (
        this.orderInfo.campaignDataDTO.raffleAssignmentStatus ===
        this.raffleStatusEnum.PENDING
      ) {
        this.calculateRemainingHours(
          this.orderInfo.campaignDataDTO.declineVehicleDeadline
        );
      } else {
        this.pastDate = true;
        this.remainingHours = 0;
      }
    }

    if (!!this.orderInfo && !!this.orderInfo.documents) {
      // Recorrer la lista de documentos en orderInfo.documents y guardarlos para mostrarlos en la tabla
      for (const document of this.orderInfo.documents) {
        const newDataSourceItem = {
          documentType: document.type,
          document: document.name,
          date: this.formatDate(document.creationDate),
          status: this.translate.translateStatusDocs(document.status),
          id: document.id,
          spinner: false
        };

        this.dataSource.push(newDataSourceItem);
      }
    }
  }

  retributionTranslation(retribution: string): string {
    return retribution === 'PRIMARY'
      ? (this.retributionText = i18next.t('primary'))
      : retribution === 'PRIMARY_ENDOWMENT'
        ? (this.retributionText = i18next.t('primaryEndowment'))
        : retribution === 'SECONDARY_ENDOWMENT'
          ? (this.retributionText = i18next.t('secondaryEndowment'))
          : (this.retributionText = i18next.t('secondary'));
  }

  translateFuelType(fuelType: string) {
    return i18next.t(fuelType);
  }

  filterDocumentsByUserCategory(): any[] {
    if (this.user?.category === 'TMK' || this.user?.category === 'OMK') {
      return this.dataSource.filter((doc) => doc.documentType !== 'PAYROLL');
    } else {
      return this.dataSource.filter(
        (doc) => doc.documentType !== 'CERTIFICATE'
      );
    }
  }

  formatDate(date: string) {
    if (date) {
      const dateObject = new Date(date);
      const day = dateObject.getDate();
      const month = dateObject.getMonth() + 1;
      const year = dateObject.getFullYear();
      const formattedDay = day < 10 ? '0' + day : day;
      const formattedMonth = month < 10 ? '0' + month : month;
      const formattedDate = `${formattedDay}/${formattedMonth}/${year}`;
      return formattedDate;
    } else {
      return '-';
    }
  }

  calculateRemainingHours(dateDecline: string): void {
    if (!!dateDecline) {
      const limitDate = new Date(`${dateDecline}T23:59:59`);
      const nowDate = new Date();

      if (nowDate > limitDate) {
        this.pastDate = true;
        this.remainingHours = 0;
      } else {
        this.pastDate = false;
        const difference = limitDate.getTime() - nowDate.getTime();
        this.remainingHours = Math.floor(difference / (1000 * 60 * 60));
      }
    } else {
      this.pastDate = true;
      this.remainingHours = 0;
    }
  }

  rejectVehicle() {
    this.orderService.rejectCampaign(this.orderInfo?.requestNumber).subscribe({
      next: () => {
        this.dialog.open(FeedbackModalComponent, {
          width: '400px',
          data: {
            text: i18next.t('rejectVehicleOK'),
            close: true,
            theme: 'ligth'
          }
        });
      },
      error: () => {
        this.dialog.open(FeedbackModalComponent, {
          width: '400px',
          data: {
            text: i18next.t('rejectVehicleKO'),
            close: true,
            theme: 'ligth'
          }
        });
      },
      complete: () => {
        console.log('Fetch complete');
      }
    });
  }

  updateDocumentsTable(doc: any) {
    const index = this.dataSource.findIndex(
      (d) => d.documentType === doc.documentType
    );

    const today = new Date();
    const todayDate = today.toISOString();

    if (index !== -1) {
      this.dataSource[index].document = doc.fileName;
      this.dataSource[index].status = this.translate.translateStatusDocs(
        LeasingStatusDocs.IN_REVIEW
      );
      this.dataSource[index].date = this.formatDate(todayDate);
      this.cdr.detectChanges();
    }
  }

  uploadDocument(doc: any) {
    const dialogRef = this.dialog.open(DragDropComponent, {
      disableClose: true,
      data: {
        docs: [],
        nisTimestamp: '',
        id: doc.id,
        docType: doc.documentType
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.updateDocumentsTable(result);
      }
    });
  }

  downloadDocument(element: { id: string; document: any; spinner: boolean }) {
    const documentKey: DocumentKey = { id: element.id };
    element.spinner = true;

    this.dataEntryService.downloadDocument(documentKey).subscribe({
      next: (resp: any) => {
        saveAs(resp, element.document);
        element.spinner = false;
      },
      error: () => {
        this.dialog.open(FeedbackModalComponent, {
          data: {
            text: i18next.t('errorDownload'),
            close: true,
            theme: 'ligth'
          }
        });
      }
    });
  }

  calculateTotalFee(car: any): string {
    const parseNumber = (value: any): number => {
      if (typeof value === 'number') return value;
      if (typeof value === 'string') {
        const cleaned = value.replace(/[^\d,.-]/g, '').replace(',', '.');
        return parseFloat(cleaned) || 0;
      }
      return 0;
    };

    const leasing = parseNumber(car?.prices?.leasingRE);
    const fee = parseNumber(car?.prices?.fee);
    const total = leasing + fee;

    return (
      total.toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' €'
    );
  }

  reloadImage() {
    this.spinnerImage = true;
    this.orderService
      .getDetailRequest(this.orderInfo.requestNumber, true)
      .subscribe({
        next: (res) => {
          this.orderInfo = res;
          if (!!this.orderInfo.vehicle) {
            this.car = this.orderInfo.vehicle;
          } else if (!!this.orderInfo.newVehicleDTO) {
            this.car = this.orderInfo.newVehicleDTO;
          }
          this.spinnerImage = false;
        },
        error: () => {
          this.spinnerImage = false;
        }
      });
  }
}
